module.exports = __webpack_public_path__ + "img/reel.058304c1.png";